import React from 'react';
import Spline from '@splinetool/react-spline';

const Sexy = () => (
  <Spline scene="https://prod.spline.design/tUymH1SKV72kaq6i/scene.splinecode" />
);

export default Sexy;
